var _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 24,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 24,
    ry: 9,
    transform: "rotate(60 32 32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 24,
    ry: 9,
    transform: "rotate(120 32 32)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.c3d71477e343f0fd18e74b9ecb10b3a6.svg";
export { ForwardRef as ReactComponent };